import type { EnemyConfig } from '../types';

export const ENEMY_CONFIGS: Record<string, EnemyConfig> = {
  slime: {
    id: 'slime',
    name: '史莱姆',
    hp: 30,
    speed: 1.5,
    armor: 0,
    magicResist: 0,
    reward: 5,
    flying: false,
    color: '#7cb342',
    radius: 6,
  },
  wolf: {
    id: 'wolf',
    name: '狼',
    hp: 45,
    speed: 3.0,
    armor: 0,
    magicResist: 0,
    reward: 8,
    flying: false,
    color: '#8d6e63',
    radius: 6,
  },
  orc: {
    id: 'orc',
    name: '兽人',
    hp: 120,
    speed: 1.2,
    armor: 5,
    magicResist: 0,
    reward: 15,
    flying: false,
    color: '#558b2f',
    radius: 8,
  },
  flyer: {
    id: 'flyer',
    name: '飞行者',
    hp: 60,
    speed: 2.0,
    armor: 0,
    magicResist: 0,
    reward: 10,
    flying: true,
    color: '#29b6f6',
    radius: 5,
  },
  shielder: {
    id: 'shielder',
    name: '盾兵',
    hp: 200,
    speed: 1.0,
    armor: 15,
    magicResist: 0,
    reward: 25,
    flying: false,
    color: '#78909c',
    radius: 8,
  },
  ghost: {
    id: 'ghost',
    name: '幽灵',
    hp: 90,
    speed: 2.5,
    armor: 0,
    magicResist: 20,
    reward: 12,
    flying: true,
    color: '#b39ddb',
    radius: 6,
  },
  fireElemental: {
    id: 'fireElemental',
    name: '火元素',
    hp: 180,
    speed: 1.8,
    armor: 0,
    magicResist: 30,
    reward: 18,
    flying: false,
    color: '#ff5722',
    radius: 8,
  },
  healer: {
    id: 'healer',
    name: '治疗者',
    hp: 80,
    speed: 1.5,
    armor: 0,
    magicResist: 20,
    reward: 20,
    flying: false,
    color: '#ec407a',
    radius: 7,
  },
  bomber: {
    id: 'bomber',
    name: '自爆怪',
    hp: 50,
    speed: 2.5,
    armor: 0,
    magicResist: 0,
    reward: 12,
    flying: false,
    color: '#fdd835',
    radius: 6,
  },
  assassin: {
    id: 'assassin',
    name: '迅捷刺客',
    hp: 110,
    speed: 2.8,
    armor: 3,
    magicResist: 10,
    reward: 22,
    flying: false,
    color: '#c2185b',
    radius: 7,
    ability: 'dash',
  },
  boss: {
    id: 'boss',
    name: '森林巨兽',
    hp: 1500,
    speed: 0.8,
    armor: 20,
    magicResist: 10,
    reward: 200,
    flying: false,
    color: '#d32f2f',
    radius: 12,
    coreDamage: 5,
    bossSkill: 'summon',
  },
  lavaBoss: {
    id: 'lavaBoss',
    name: '熔岩领主',
    hp: 2500,
    speed: 0.7,
    armor: 25,
    magicResist: 20,
    reward: 300,
    flying: false,
    color: '#ff5722',
    radius: 14,
    coreDamage: 8,
    bossSkill: 'burningGround',
  },
  skyBoss: {
    id: 'skyBoss',
    name: '天空暴君',
    hp: 2000,
    speed: 1.0,
    armor: 15,
    magicResist: 15,
    reward: 350,
    flying: true,
    color: '#7c4dff',
    radius: 12,
    coreDamage: 6,
    bossSkill: 'spawnFlyers',
  },
};
